module.exports = __webpack_public_path__ + "img/3.033d4853.png";